import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import Haircut from './components/Haircut';
import HairColour from './components/HairColour';
import HairTreatment from './components/HairTreatment';
import PartyMakeup from './components/PartyMakeup';
import BeardStyling from './components/BeardStyling';
import BridalHairMakeup from './components/BridalHairMakeup';
import Footer from './components/Footer';
import SocialSidebar from './components/SocialSidebar';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <Header />
      <SocialSidebar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/haircut" element={<Haircut />} />
        <Route path="/hair-colour" element={<HairColour />} />
        <Route path="/hair-treatment" element={<HairTreatment />} />
        <Route path="/party-makeup" element={<PartyMakeup />} />
        <Route path="/beard-styling" element={<BeardStyling />} />
        <Route path="/bridal-hair-makeup" element={<BridalHairMakeup />} />
      </Routes>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
